import { connect } from 'react-redux'
import MobilityOptionsSearch from '../../components/mobility-options/MobilityOptionsSearch'
import { searchMobilityOptions } from '../../state/actions/mobility-options/index'
import { IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {}
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onInputChange: (query: string) => {
      dispatch(searchMobilityOptions(query))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobilityOptionsSearch)



// WEBPACK FOOTER //
// ./src/containers/mobility-options/MobilityOptionsSearch.tsx